<template>
  <div
    class="vx-card p-6 flex flex-col"
    id="crew-status-list"
    ref="crewStatusList"
  >
    <!-- アラート表示領域 -->
    <div class="flex items-center flex-wrap">
      <div class="latest-alert-label">直近のアラート<br />発生人数</div>
      <div id="alert-area" class="flex items-center flex-wrap gap-3">
        <!-- 時間超過  -->
        <div
          id="count-overtime"
          class="vx-card alert-card"
          :class="{
            [clickedAlertClass]: isOverTimeSelected,
            'cursor-pointer': isOverTimeExisits,
          }"
          @click="isOverTimeExisits && alertClicked('overtime')"
        >
          <span class="number" :class="overtimeAlertColor">{{ overtime }}</span>
          <span class="people" :class="overtimeAlertColor">人</span>
          <div class="description-area">
            <div class="description">時間超過</div>
            <vx-tooltip-with-slot-text position="bottom">
              <!-- ホバー時に表示するツールチップ -->
              <template v-slot:text>
                <tooltip-text-overtime />
              </template>
              <!-- ホバー対象 -->
              <template v-slot:inner>
                <div class="info-icon">
                  <span class="material-icons" :style="{ 'font-size': '20px' }">
                    info
                  </span>
                </div>
              </template>
            </vx-tooltip-with-slot-text>
          </div>
        </div>
        <!-- 休憩不足 -->
        <div
          id="count-lack-of-rest"
          class="vx-card alert-card"
          :class="{
            [clickedAlertClass]: isLackOfRestSelected,
            'cursor-pointer': isLackOfRestExisits,
          }"
          @click="isLackOfRestExisits && alertClicked('lackOfRest')"
        >
          <span class="number" :class="countLackOfRestAlertColor">{{
            lackOfRest
          }}</span>
          <span class="people" :class="countLackOfRestAlertColor">人</span>
          <div class="description-area">
            <div class="description">休憩不足</div>
            <vx-tooltip-with-slot-text position="bottom">
              <!-- ホバー時に表示するツールチップ -->
              <template v-slot:text>
                <tooltip-text-lack-of-rest />
              </template>
              <!-- ホバー対象 -->
              <template v-slot:inner>
                <div class="info-icon">
                  <span class="material-icons" :style="{ 'font-size': '20px' }">
                    info
                  </span>
                </div>
              </template>
            </vx-tooltip-with-slot-text>
          </div>
        </div>
        <!-- 時間超過の恐れ -->
        <div
          id="count-fear-of-overtime"
          class="vx-card alert-card"
          :class="{
            [clickedWarningClass]: isFearOfOvertimeSelected,
            'cursor-pointer': isFearOfOvertimeExisits,
          }"
          @click="isFearOfOvertimeExisits && alertClicked('fearOfOvertime')"
        >
          <span class="number" :class="countFearOfOvertimeAlertColor">{{
            fearOfOvertime
          }}</span>
          <span class="people" :class="countFearOfOvertimeAlertColor">人</span>
          <div class="description-area">
            <div class="description">時間超過の恐れ</div>
            <vx-tooltip-with-slot-text position="bottom">
              <!-- ホバー時に表示するツールチップ -->
              <template v-slot:text>
                <tooltip-text-fear-overtime />
              </template>
              <!-- ホバー対象 -->
              <template v-slot:inner>
                <div class="info-icon">
                  <span class="material-icons" :style="{ 'font-size': '20px' }">
                    info
                  </span>
                </div>
              </template>
            </vx-tooltip-with-slot-text>
          </div>
        </div>
      </div>
    </div>

    <!-- 検索エリア -->
    <div class="search-area">
      <vs-divider />
      <div class="flex items-center">
        <vs-input
          class="w-64 pr-4 crew-incremental-search"
          placeholder="氏名で検索"
          v-model="searchCrewName"
          icon="search"
          icon-no-border
        ></vs-input>
        <v-select
          class="w-64 pr-4"
          placeholder="船名"
          v-model="selectedVessel"
          label="name"
          :options="crewVesselList"
        >
          <template v-slot:no-options>-</template>
        </v-select>
        <v-select
          class="w-64 pr-4"
          placeholder="職名"
          v-model="selectedRole"
          label="value"
          :options="crewRoleList"
        >
          <template v-slot:no-options>-</template>
        </v-select>
      </div>
      <vs-divider />
    </div>
    <ag-grid-vue
      class="ag-theme-material w-100 my-6 ag-grid-table flex-shrink-1"
      ref="agGridTableCrewStatusList"
      :gridOptions="gridOptions"
      :defaultColDef="defaultColDef"
      :columnDefs="columnDefs"
      :rowData="crewData"
      colResizeDefault="shift"
      :suppressCellFocus="true"
      :animateRows="false"
      :floatingFilter="false"
    >
    </ag-grid-vue>

    <!-- ページネーション領域 -->
    <div class="flex justify-end items-center" style="margin: 0.6rem 0">
      <div style="margin-right: 2rem">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              p-4
              border border-solid
              d-theme-border-grey-light
              rounded-full
              d-theme-dark-bg
              cursor-pointer
              flex
              items-center
              justify-between
              font-medium
            "
          >
            <span class="mr-2"
              >{{ fromCrewCount }}
              -
              {{ toCrewCount }}
              / {{ totalCrewCount }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- ページに表示するレコードを変更 -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="onChangePageSize(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(75)">
              <span>75</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="onChangePageSize(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!-- ページネーション -->
      <div>
        <vs-pagination
          v-if="isReadyPagination"
          :total="pageable.total_pages"
          :max="7"
          v-model="currentPage"
          :color="AISEA_COLOR.BLUE"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import vSelect from "vue-select";
import _ from "lodash";

import CellRendererCrewName from "./cell-renderer/CellRendererCrewName";
import CellRendererHoursOfWork24h from "./cell-renderer/CellRendererHoursOfWork24h";
import CellRendererHoursOfRest from "./cell-renderer/CellRendererHoursOfRest";
import CellRendererHoursOfWork1w from "./cell-renderer/CellRendererHoursOfWork1w";
import CellRendererHoursOfOverwork28d from "./cell-renderer/CellRendererHoursOfOverwork28d";
import CellRendererHoursOfWork5d from "./cell-renderer/CellRendererHoursOfWork5d";

import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const enterpriseCrewApi = AiseaApiFactory.get("enterpriseCrewTimesheetRecord");

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("crewManningVessels");
import TooltipTextOvertime from "./tooltip-text/TooltipTextOvertime.vue";
import TooltipTextLackOfRest from "./tooltip-text/TooltipTextLackOfRest.vue";
import TooltipTextFearOvertime from "./tooltip-text/TooltipTextFearOvertime.vue";
import VxTooltipWithSlotText from "@/layouts/components/vx-tooltip/VxTooltipWithSlotText.vue";

export default {
  name: "CrewStatusList",
  mixins: [DeviceInfoMixin, ColorMixin],
  components: {
    AgGridVue,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererCrewName,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererHoursOfWork24h,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererHoursOfOverwork28d,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererHoursOfWork5d,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererHoursOfRest,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererHoursOfWork1w,
    VxTooltipWithSlotText,
    TooltipTextOvertime,
    TooltipTextLackOfRest,
    TooltipTextFearOvertime,
  },
  data() {
    return {
      columnDefs: null,
      gridColumnApi: null,
      rowData: [],
      gridApi: null,
      overtime: null,
      lackOfRest: null,
      fearOfOvertime: null,
      searchCrewName: "",
      selectedRole: null,
      selectedVessel: null,
      selectedAlert: null,
      actionButtonTimer: null,
      agGridScrollPosition: -1,
      roleList: [],
      isReadyPagination: true,
      alertColorClass: "alert-color",
      warningColorClass: "warning-color",
      normalColorClass: "normal-color",
      clickedAlertClass: "alert-clicked",
      clickedWarningClass: "warning-clicked",
      hoverMenuClassList: [
        "hover-menu-hour-of-work-24h",
        "hover-menu-hour-of-rest-24h",
        "hover-menu-hour-of-work-1h",
      ],
      gridOptions: {
        localeText: { noRowsToShow: "表示する船員労務状況がありません" },
        context: {
          componentParent: this,
        },
      },

      pageable: {
        page: 0,
        total_elements: 0,
        total_pages: 1,
      },

      searchCondition: {
        name: null,
        enterprise_crew_id: null,
        enterprise_crew_role_id: null,
        enterprise_manning_vessel_id: null,
        page: 0,
        size: 50,
        overtime: false,
        lack_of_rest: false,
        fear_of_overtime: false,
      },

      currentPage: 1,
      pageSize: 50,

      defaultColDef: {
        // flex: 1,
        resizable: true,
        sortable: false,
        wrapText: true,
        autoHeight: false,
      },
      // 24時間あたりの労働時間
      workTimeDaysCellRules: {
        "cell-danger": params => params.data.is_hour_of_work24h_critical, // 警告: 14時間超
        "cell-warn": params =>
          !params.data.is_hour_of_work24h_critical &&
          params.data.is_hour_of_work24h_warning, // 注意: 10時間以上〜14時間以内
      },

      // 5日間あたりの労働時間
      workTimeFiveDaysCellRules: {
        "cell-warn": params => params.data.is_hour_of_work5d_warning, // 注意: 50時間以上
      },

      // 1週間あたりの労働時間
      workTimeWeeksCellRules: {
        "cell-danger": params => params.data.is_hour_of_work1w_critical, // 警告: 72時間超
        "cell-warn": params =>
          !params.data.is_hour_of_work1w_critical &&
          params.data.is_hour_of_work1w_warning, // 注意: 68時間以上〜72時間以内
      },

      // 28日間あたりの時間外労働時間
      overworkTwentyEightDaysCellRules: {
        "cell-danger": params =>
          params.data.is_hour_of_overtime_work28d_critical, // 警告: 56時間超
      },

      // 24時間あたりの休息時間
      restTimeDevisionCellRules: {
        "cell-danger": params => params.data.is_hour_of_rest24h_critical, // 警告: 6時間未満
      },
    };
  },
  watch: {
    selectedRole(val) {
      this.searchCondition.enterprise_crew_role_id = val ? val.id : null;
      this.initializePageIndex();
      this.fetchCrewTimesheetRecord(this.searchCondition);
    },

    selectedVessel(val) {
      this.searchCondition.enterprise_manning_vessel_id = val ? val.id : null;
      this.initializePageIndex();
      this.fetchCrewTimesheetRecord(this.searchCondition);
    },

    searchCrewName(val) {
      this.searchCondition.name = val;
      this.fetchCrewTimesheetRecord(this.searchCondition);
      this.initializePageIndex();
    },

    currentPage() {
      this.searchCondition.page = this.getCurrentPage();
      this.searchCrewTimesheetRecords();
    },
  },
  computed: {
    ...mapState(["manningVessels", "crewRoles"]),
    crewRoleList() {
      if (!this.crewRoles) return [];
      return _.cloneDeep(this.crewRoles).map(item => {
        item.value = item.name;
        return item;
      });
    },
    crewVesselList() {
      if (!this.manningVessels) return [];
      return _.cloneDeep(this.manningVessels); //.map(item => item.name)
    },
    crewData() {
      return _.cloneDeep(this.rowData).map(item => {
        if (item.enterprise_crew_role_map) {
          item.role = Object.values(item.enterprise_crew_role_map).map(y =>
            this.$t(`Views.Crew.${y}`)
          )[0];
          console.log(item.role);
        }
        if (item.enterprise_manning_vessel_map) {
          item.vessel = Object.values(item.enterprise_manning_vessel_map)[0];
        }
        return item;
      });
    },
    fromCrewCount() {
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    toCrewCount() {
      return this.totalCrewCount - this.currentPage * this.pageSize > 0
        ? this.currentPage * this.pageSize
        : this.totalCrewCount;
    },
    totalCrewCount() {
      if (this.pageable) return this.pageable.total_elements;
      else return 0;
    },

    overTimeClass() {
      if (this.selectedAlert !== "overtime") return;
      if (!this.overtime) return;
      return this.clickedAlertClass;
    },

    lackOfRestClass() {
      if (this.selectedAlert !== "lackOfRest") return;
      if (!this.lackOfRest) return;
      return this.clickedAlertClass;
    },

    fearOfOvertimeClass() {
      if (this.selectedAlert !== "fearOfOvertime") return;
      if (!this.fearOfOvertime) return;
      return this.clickedWarningClass;
    },

    overtimeAlertColor() {
      if (this.overtime > 0) return this.alertColorClass;
      return this.normalColorClass;
    },
    countLackOfRestAlertColor() {
      if (this.lackOfRest > 0) return this.alertColorClass;
      return this.normalColorClass;
    },
    countFearOfOvertimeAlertColor() {
      if (this.fearOfOvertime > 0) return this.warningColorClass;
      return this.normalColorClass;
    },

    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return this.pageSize;
    },
    isOverTimeExisits() {
      return this.overtime > 0;
    },
    isLackOfRestExisits() {
      return this.lackOfRest > 0;
    },
    isFearOfOvertimeExisits() {
      return this.fearOfOvertime > 0;
    },

    isOverTimeSelected() {
      return this.selectedAlert === "overtime";
    },
    isLackOfRestSelected() {
      return this.selectedAlert === "lackOfRest";
    },
    isFearOfOvertimeSelected() {
      return this.selectedAlert === "fearOfOvertime";
    },
    searchConditionOfAlert() {
      return {
        overtime: this.selectedAlert === "overtime",
        lack_of_rest: this.selectedAlert === "lackOfRest",
        fear_of_overtime: this.selectedAlert === "fearOfOvertime",
      };
    },
  },
  methods: {
    ...mapActions(["fetchAllManningVessels", "fetchAllCrewRoles"]),

    initializePageIndex() {
      this.currentPage = 1;
    },

    onChangePageSize(size) {
      this.gridApi.paginationSetPageSize(size);
      this.pageSize = size;
      this.currentPage = 1;
      this.searchCondition.size = size;

      this.fetchCrewTimesheetRecord(this.searchCondition);
    },

    async searchCrewTimesheetRecords() {
      await this.fetchCrewTimesheetRecord(this.searchCondition);
    },

    getCurrentPage() {
      return this.currentPage - 1;
    },
    onFirstDataRendered(_) {
      this.autoSizeAll();
    },

    setAlertClickedColor(val) {
      if (this.selectedAlert === val) {
        this.selectedAlert = null;
        return;
      }
      this.selectedAlert = val;
    },

    async fetchCrewTimesheetRecord(payload) {
      try {
        const res = await enterpriseCrewApi.search(payload);
        if (!res.status) return;
        this.overtime = res.data.overtime;
        this.lackOfRest = res.data.lack_of_rest;
        this.fearOfOvertime = res.data.fear_of_overtime;
        this.rowData =
          res.data.inline_response_enterprise_crew_timesheet_records;
        this.pageable = res.data.pageable;

        this.currentPage = payload.page + 1;
      } catch (error) {
        console.error(error);
        return;
      }
    },
    alertClicked(alertStatus) {
      this.setAlertClickedColor(alertStatus);
      this.initializePageIndex();

      this.searchCondition = {
        ...this.searchCondition,
        ...this.searchConditionOfAlert,
      };

      this.fetchCrewTimesheetRecord(this.searchCondition);
    },
    autoSizeAll() {
      if (this.gridColumnApi) {
        let allColumnIds = [];
        if (this.gridColumnApi && this.gridColumnApi.getAllColumns()) {
          this.gridColumnApi.getAllColumns().forEach(function(column) {
            allColumnIds.push(column.getId());
          });
          this.gridColumnApi.autoSizeColumns(allColumnIds, false);
        }
        if (
          this.$refs.agGridTableAdminAccount &&
          this.$refs.agGridTableAdminAccount.$el.getBoundingClientRect().width >
            0
        ) {
          this.gridApi.sizeColumnsToFit(); // TODO: 横スクロールありの場合は、別途調整
        }
      }
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerName: "氏名",
        field: "crew_name",
        cellRenderer: "CellRendererCrewName",
        colId: "crew_name",
        width: 240,
      },
      {
        headerName: "船名",
        field: "vessel",
        width: 150,
        colId: "vessel",
      },
      {
        headerName: "職名",
        field: "role",
        colId: "role",
        width: 150,
      },
      {
        headerName: "労働時間\n/24h",
        field: "hour_of_work24h",
        cellRenderer: "CellRendererHoursOfWork24h",
        cellClassRules: this.workTimeDaysCellRules,
        colId: "hour_of_work24h",
        width: 100,
      },
      {
        headerName: "分割休息時間\n/24h",
        field: "hour_of_rest24h",
        cellRenderer: "CellRendererHoursOfRest",
        cellClassRules: this.restTimeDevisionCellRules,
        colId: "hour_of_rest24h",
        width: 100,
      },
      {
        headerName: "過去5日間以内\nの労働時間",
        field: "hour_of_work5d",
        cellRenderer: "CellRendererHoursOfWork5d",
        cellClassRules: this.workTimeFiveDaysCellRules,
        colId: "hour_of_work5d",
        width: 100,
      },
      {
        headerName: "労働時間\n/1w",
        field: "hour_of_work1w",
        cellRenderer: "CellRendererHoursOfWork1w",
        cellClassRules: this.workTimeWeeksCellRules,
        colId: "hour_of_work1w",
        width: 100,
      },
      {
        headerName: "過去28日間\nの時間外労働",
        field: "hour_of_overtime_work28d",
        cellRenderer: "CellRendererHoursOfOverwork28d",
        cellClassRules: this.overworkTwentyEightDaysCellRules,
        colId: "hour_of_overtime_work28d",
        width: 100,
      },
      {
        headerName: "休日\n取得数",
        field: "num_of_day_off",
        colId: "num_of_day_off",
        width: 100,
      },
      {
        headerName: "残り\n休日数",
        field: "num_of_remaining_day_off",
        colId: "num_of_remaining_day_off",
        width: 100,
      },
      {
        headerName: "有給取得\n日数",
        field: "num_of_paid_off",
        colId: "num_of_paid_off",
        width: 100,
      },
      {
        headerName: "残り有給\n休暇数",
        field: "num_of_remaining_paid_off",
        colId: "num_of_remaining_paid_off",
        width: 100,
      },
    ];

    this.gridOptions = {
      ...this.gridOptions,
      onFirstDataRendered: this.onFirstDataRendered,
    };
  },
  async created() {
    await this.searchCrewTimesheetRecords();
    await this.fetchAllCrewRoles();
    await this.fetchAllManningVessels();
  },

  async mounted() {
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";

    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#crew-status-list {
  --vs-primary: 3, 155, 229;

  .ag-cell {
    font-size: 16px;
    font-weight: 400;
  }

  .ag-header-cell-text {
    font-size: 12px;
    font-weight: 600;
  }

  .latest-alert-label {
    margin-right: 10px;
    font-size: 15px;
    font-weight: 600;
  }

  #alert-area {
    flex-grow: 1;
    .alert-card {
      width: 210px;
      height: 80px;
      padding: 8px 16px;
      border-radius: 6px;

      .number {
        font-size: 26px;
        font-weight: 600;
      }

      .people {
        font-size: 14px;
        font-weight: 400;
      }

      .description-area {
        display: flex;
        .description {
          font-size: 14px;
          font-weight: 600;
          flex-grow: 1;
        }
        .info-icon .material-icons {
          color: $aisea-mouse-gray;
          transition: 0.3s;
          &:hover {
            color: $aisea-gray;
          }
        }
      }

      .alert-color {
        color: #ff5252;
      }
      .warning-color {
        color: #ffd54f;
      }
      .normal-color {
        color: #4fb0f7;
      }
    }

    .warning-clicked {
      background-color: #fff8e4;
    }

    .alert-clicked {
      background-color: #fbeded;
    }
  }
  .search-area {
    .close-btn {
      padding: 9px 20px;
    }
  }

  .ag-theme-material {
    font-size: 12px;
    overflow: visible;
  }

  .ag-header-cell-label .ag-header-cell-text {
    white-space: pre-wrap !important;
    overflow: visible;
    overflow-wrap: break-word;
  }

  a.filter-btn {
    border: 1px solid;
    border-radius: 40px;
    border-color: $aisea-mouse-gray;
    padding: 5px 10px;
    color: $aisea-black;

    span {
      padding-left: 5px;
    }
  }

  .cell-warn {
    color: $aisea-white;
    background-color: #ffbf00;
    font-weight: 600;
  }

  .cell-danger {
    color: $aisea-white;
    background-color: #eb5f56;
    font-weight: 600;
  }

  #crew-list-hover-menu {
    .hover-area {
    }
  }

  .crew-edit-form-row {
    flex-direction: column;
    margin: 24px 0;
    padding-right: 8px;

    label {
      font-family: $aisea-font-family;
      font-size: 14px;
      font-weight: 600;
    }
  }
  ï .v-select {
    font-family: $aisea-font-family;
    font-size: 16px;
    font-weight: 400;

    input {
      height: 2rem;
    }
  }

  .crew-incremental-search {
    .vs-inputx {
      background-color: $aisea-pure-white;
      font-family: $aisea-font-family;
      font-size: 16px !important;
      font-weight: 400;
      color: $aisea-dark-gray;
    }

    .vs-input--input {
      height: 32px;
    }

    .vs-input--icon {
      font-size: 16px;
    }
    .vs-input--placeholder {
      color: $aisea-light-gray !important;
      margin-top: -0.1rem !important;
    }
  }
}
</style>
